import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { FeatureArticleContent } from '../../models/feature-article.model';

@Component({
  selector: 'vm-feature-article-section',
  templateUrl: './feature-article-section.component.html',
  styleUrls: ['./feature-article-section.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FeatureArticleSectionComponent {
  @Input() data: FeatureArticleContent;
  @Output() continue = new EventEmitter();

  public onContinue(uid: string) {
    this.continue.emit(uid);
  }
}
